import styled from 'styled-components'

export const InfoRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    &:last-child{
        margin-bottom: 0;
    }
`;

export const InfoText = styled.div`
    flex: 1;
    margin-left: 10px;
    font-size: 15px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
`;